// extracted by mini-css-extract-plugin
export default {"root":"_4tW00","label":"_2GvRQ"};